module.exports = __webpack_public_path__ + "34bc775d/img/google.68f3823e.svg";